import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../styles/scss/components/industrial/numbered-steps-item.module.scss';
import { supSub } from '../../services/util';

const NumberedStepsItem = ({ number, title, description, bulletPoints, position, isLast }) => {
  return (
    <div className={`${styles.item} ${styles[position]} ${isLast ? styles.last : ''}`}>
      {position === 'left' ? (
        <div className={styles.contentWrapper}>
          <div className={styles.textSide}>
            <div className={styles.textContent}>
              <h4 className={styles.title} dangerouslySetInnerHTML={{ __html: supSub(title) }} />
              {description && <p className={styles.description} dangerouslySetInnerHTML={{ __html: supSub(description) }} />}
              
              {bulletPoints && bulletPoints.length > 0 && (
                <ul className={styles.bulletPoints}>
                  {bulletPoints.map((point, index) => (
                    <li key={index} className={styles.bulletPoint}>
                      <span className={styles.bulletPointTitle} dangerouslySetInnerHTML={{ __html: supSub(point.title) }} />
                      {point.description && (
                        <span className={styles.bulletPointDescription}>
                          {' - '}
                          <span dangerouslySetInnerHTML={{ __html: supSub(point.description) }} />
                        </span>
                      )}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
          <div className={styles.centerLine}>
            <div className={styles.bullet}>
              <span className={styles.number}>{number}</span>
            </div>
          </div>
          <div className={styles.emptySide}></div>
        </div>
      ) : position === 'right' ? (
        <div className={styles.contentWrapper}>
          <div className={styles.emptySide}></div>
          <div className={styles.centerLine}>
            <div className={styles.bullet}>
              <span className={styles.number}>{number}</span>
            </div>
          </div>
          <div className={styles.textSide}>
            <div className={styles.textContent}>
              <h4 className={styles.title} dangerouslySetInnerHTML={{ __html: supSub(title) }} />
              {description && <p className={styles.description} dangerouslySetInnerHTML={{ __html: supSub(description) }} />}
              
              {bulletPoints && bulletPoints.length > 0 && (
                <ul className={styles.bulletPoints}>
                  {bulletPoints.map((point, index) => (
                    <li key={index} className={styles.bulletPoint}>
                      <span className={styles.bulletPointTitle} dangerouslySetInnerHTML={{ __html: supSub(point.title) }} />
                      {point.description && (
                        <span className={styles.bulletPointDescription}>
                          {' - '}
                          <span dangerouslySetInnerHTML={{ __html: supSub(point.description) }} />
                        </span>
                      )}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

NumberedStepsItem.propTypes = {
  number: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  bulletPoints: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string
    })
  ),
  position: PropTypes.oneOf(['left', 'right']).isRequired,
  isLast: PropTypes.bool
};

export default NumberedStepsItem;
